// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"9afe3285","126":"8f24e5b7","171":"c404c216","388":"c62dbbf5","453":"8132d331"}[chunkId] + ".chunk.js";
};